<template>
    <v-card
        v-if="$vuetify.breakpoint.xs && currentRoute"
        class="overflow-hidden rounded-0"
    >
        <v-bottom-navigation
            v-model="bottomNav"
            app
            grow
            hide-on-scroll
            scroll-threshold="200"
            active-class="grey lighten-2"
            color="primary"
            background-color="grey lighten-4"
            shift
        >
            <v-btn
                v-for="(link, index) in filteredLinks"
                :key="index"
                :to="{ name: link.link }"
                text
            >
                <v-icon>{{ link.icon }}</v-icon>
                <span>{{ link.title }}</span>
            </v-btn>
        </v-bottom-navigation>
    </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'BottomNav',

    data: () => ({
        bottomNav: 0,
        noBotRoutes: ['login', 'maintenance', 'databaseManagement'],
        links:  [
            {
                link: 'dashboard',
                icon: 'mdi-chart-bar',
                title: 'Dashboard',
                permission: [
                    'isDistributor',
                ],
            },
            {
                link: 'teletrabajo',
                icon: 'mdi-database',
                title: 'Teletrabajo',
                permission: [
                    'isDistributor',
                ],
            },
            {
                link: 'gerencia',
                icon: 'mdi-notebook',
                title: 'Gerencia',
                permission: [
                    'hasManagerPermission',
                    'isDistributor',
                ],
            },
            {
                link: 'managementBase',
                icon: 'mdi-book-information-variant',
                title: 'Administración',
                permission: [
                    'hasAdminPermission',
                    'isDistributor',
                ],
            },
            {
                link: 'devicemanagement',
                icon: 'mdi-cellphone',
                title: 'Dispositivos',
                permission: [
                    '!hasManagerPermission',
                    'isDistributor',
                ],
            },
            {
                link: 'areaPersonal',
                icon: 'mdi-basket-plus-outline',
                title: 'Area Personal',
                permission: [
                    'isDistributor',
                ],
            },
            {
                link: 'fichaje',
                icon: 'mdi-timer-outline',
                title: 'Fichaje',
                permission: [
                    '!isDistributor',
                ],
            },
            {
                link: 'documentos',
                icon: 'mdi-folder-account-outline',
                title: 'Documentos',
                permission: [
                    '!isDistributor',
                ],
            },
            {
                link: 'vacaciones',
                icon: 'mdi-beach',
                title: 'Vacaciones',
                permission: [
                    '!isDistributor',
                ],
            },
            {
                link: 'rrhh',
                icon: 'mdi-account-group',
                title: 'RRHH',
                permission: [
                    '!isDistributor',
                    'hasAdminPermission',
                ],
            }
        ]
    }),
    computed: {
        currentRoute() {
            // console.log(this.$route.name);
            return !this.noBotRoutes.includes(this.$route.name);
        },
        rol() {
            return this.$store.state.general.rolesDecode[this.rolEncoded];
        },
        ...mapState('login', {
            fullName: (state) => state.nombre,
            rolEncoded: (state) => state.rol,
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasAdminPermission: 'hasAdminPermission',
            isDistributor: 'isDistributor',
        }),
        color() {
            switch (this.bottomNav) {
                case 0:
                    return 'blue-grey';
                case 1:
                    return 'teal';
                case 2:
                    return 'brown';
                case 3:
                    return 'indigo';
            }
        },
        filteredLinks() {
            return this.links.filter((link) => this.permissionChecker(link.permission));
        },
    },
    methods: {
        permissionChecker(permissions) {
            let hasPermission = true;
            
            permissions.forEach((permission) => {
                let permissiopnString = `this.${permission}`;
                if (permissiopnString.includes('!')) {
                    // find and delete ! character
                    permissiopnString = permissiopnString.replace('!', '');
                    permissiopnString = `!${permissiopnString}`;
                }

                hasPermission = hasPermission && eval(permissiopnString);
            });

            return hasPermission;
        },
    },
};
</script>